/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Carrier_Select_AddressInputs */

const en_orders_carrier_select_address = /** @type {(inputs: Orders_Carrier_Select_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a saved address or add a new one.`)
};

const es_orders_carrier_select_address = /** @type {(inputs: Orders_Carrier_Select_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona una direccion guardada o agrega una nueva.`)
};

/**
* | output |
* | --- |
* | "Select a saved address or add a new one." |
*
* @param {Orders_Carrier_Select_AddressInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_select_address = /** @type {((inputs?: Orders_Carrier_Select_AddressInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_Select_AddressInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_select_address(inputs)
	return es_orders_carrier_select_address(inputs)
});